import apiClient from './apiClient';

// ============================================================
// Types — matched to backend models/models.go (pwc514f1)
// ============================================================

/** One abnormal delivery order in the pending approval grid */
export interface AbnormalPendingItem {
  do_no: string;
  sc_no: string;
  do_date: string | null;
  customer_code: string;
  customer_name: string;
  dept_code: string;
  dept_name: string;
  abnormal_reason: string; // P→單價異常 / Q→數量超交 / L→單價異常及數量超交
  approval_status: string; // FC120_80
}

export interface PendingResponse {
  items: AbnormalPendingItem[];
  total: number;
}

export interface ApproveResultItem {
  do_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ApprovalFilter {
  doStart: string;
  doEnd: string;
}

// FC120 full detail (reuses backend pwc204f1/models.FC120 json tags)
export interface FC120Detail {
  fc120_01: string;
  fc120_10: string;
  fc120_11: string | null;
  fc120_12: string;
  fc120_13: number;
  fc120_14: string;
  fc120_16: number;
  fc120_17: string;
  fc120_18: string;
  fc120_19: number;
  fc120_20: number;
  fc120_201: number;
  fc120_24: string;
  fc120_27: number;
  fc120_80: string;
  details?: FC121Detail[];
}

export interface FC121Detail {
  fc121_01: string;
  fc121_02: number;
  fc121_11: string;
  fc121_12: string;
  fc121_13: string;
  fc121_15: number;
  fc121_16: number;
  fc121_17: string;
  fc121_18: number;
  fc121_19: number;
  fc121_20: number;
  fc121_21: number;
  fc121_22: string;
  batches?: FC122Batch[];
}

export interface FC122Batch {
  fc122_01: string;
  fc122_02: number;
  fc122_03: number;
  fc122_11: string;
  fc122_12: number;
}

// ============================================================
// API methods
// ============================================================

export const c514Api = {
  // GET /api/pwc514f1/pending?doStart=&doEnd=
  async getPending(filter: ApprovalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/pwc514f1/pending', {
      params: {
        doStart: filter.doStart,
        doEnd: filter.doEnd,
      },
    });
    return res.data;
  },

  // GET /api/pwc514f1/detail/:doNo
  async getDetail(doNo: string): Promise<FC120Detail> {
    const res = await apiClient.get(`/api/pwc514f1/detail/${doNo}`);
    return res.data;
  },

  // POST /api/pwc514f1/approve
  async approve(doNos: string[], comment?: string): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwc514f1/approve', {
      do_nos: doNos,
      comment: comment || '',
      confirmed: true,
    });
    return res.data;
  },
};
